import { dollars } from "@loot-os/api-contract/shopifyRuleBoxForm";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { TABLE, TD, TH } from "./tableStyles";
import { useTRPC } from "./trpc";

/** The shop's variants as Loot OS holds them: what a box's drop table may contain. */
export function CatalogScreen() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const variants = useQuery(trpc.catalog.list.queryOptions());
  const sync = useMutation(
    trpc.catalog.sync.mutationOptions({
      onSuccess: (result) => {
        shopify.toast.show(
          result.complete
            ? `Synced ${result.variants} variants.`
            : "Still syncing; it finishes within a few minutes.",
        );
        void queryClient.invalidateQueries({ queryKey: trpc.catalog.list.queryKey() });
      },
    }),
  );

  return (
    <s-stack gap="base">
      <s-paragraph>
        These are the products from your store that you can put in a box. They update on their own
        when you change a product in Shopify; click "Sync now" if something looks out of date.
      </s-paragraph>
      <s-stack direction="inline">
        <s-button disabled={sync.isPending || undefined} onClick={() => sync.mutate()}>
          {sync.isPending ? "Syncing…" : "Sync now"}
        </s-button>
      </s-stack>
      {variants.isLoading ? (
        <s-paragraph>Loading your products…</s-paragraph>
      ) : (variants.data ?? []).length === 0 ? (
        <s-paragraph color="subdued">
          No products yet. Click "Sync now" to bring them in.
        </s-paragraph>
      ) : (
        <table style={TABLE}>
          <thead>
            <tr>
              <th style={TH}>Product</th>
              <th style={TH}>SKU</th>
              <th style={TH}>Inventory</th>
              <th style={{ ...TH, textAlign: "right" }}>Price</th>
            </tr>
          </thead>
          <tbody>
            {(variants.data ?? []).map((v) => (
              <tr key={v.variantGid}>
                <td style={TD}>{v.title}</td>
                <td style={TD}>{v.sku ?? "—"}</td>
                <td style={TD}>{v.tracked ? "Limited to your stock" : "Always available"}</td>
                <td style={{ ...TD, textAlign: "right" }}>{dollars(v.priceCents)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </s-stack>
  );
}
